import { Injectable } from '@angular/core';
import { Group, Device, User, TeamMember } from './models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PassParametersService {

  private index: number | null = null;
  private user: User | null = null;
  private accessLevel: string | null = null;
  private organization: Group | null = null;
  private teamMember: TeamMember | null = null;
  private email: string | null = null;

  private deviceSubject = new BehaviorSubject<Device | null>(this.getStoredDevice());
  device$ = this.deviceSubject.asObservable();

  private organizationSubject = new BehaviorSubject<Group | null>(this.getStoredOrganization());
  organization$ = this.organizationSubject.asObservable();

  constructor() { }

  private getStoredDevice(): Device | null {
    const storedDevice = sessionStorage.getItem('device');
    return storedDevice ? JSON.parse(storedDevice) : null;
  }

  private getStoredOrganization(): Group | null {
    const storedOrg = sessionStorage.getItem('organization');
    return storedOrg ? JSON.parse(storedOrg) : null;
  }

  setDevice(device: Device) {
    sessionStorage.setItem('device', JSON.stringify(device));
    this.deviceSubject.next(device);
  }

  setOrganization(organization: Group) {
    sessionStorage.setItem('organization', JSON.stringify(organization));
    this.organizationSubject.next(organization);

    // temporary
    this.organization = organization;

    // clear org
    this.organizationSubject.next(null);
  }

  // public setOrganization(organization: Organization | null) {
  //   this.organization = organization;
  // }
  public getOrganizationThenReset(): Group | null {
    const ret = this.organization;
    this.organization = null;
    return ret;
  }

  clearDevice() {
    sessionStorage.removeItem('device');
    this.deviceSubject.next(null);
  }

  clearOrganization() {
    sessionStorage.removeItem('organization');
    this.organizationSubject.next(null);
  }



  public setEmail(email: string) {
    this.email = email;
  }
  public getEmailThenReset(): string | null {
    const ret = this.email;
    this.email = null;
    return ret;
  }

  public setIndex(index: number) {
    this.index = index;
  }
  public getIndexThenReset(): number | null {
    const ret = this.index;
    this.index = null;
    return ret;
  }

  public setTeamMember(teamMember: TeamMember | null) {
    this.teamMember = teamMember;
  }
  public getTeamMemberThenReset(): TeamMember | null {
    const ret = this.teamMember;
    this.teamMember = null;
    return ret;
  }

  public setUser(user: User | null) {
    this.user = user;
  }
  public getUserThenReset(): User | null {
    const ret = this.user;
    this.user = null;
    return ret;
  }


  public setAccessLevel(accessLevel: string) {
    this.accessLevel = accessLevel;
  }

  public getAccessLevelThenReset(): string | null {
    const ret = this.accessLevel;
    this.accessLevel = null;
    return ret;
  }

}
